import Accordion from '@components/Atoms/Accordion';
import Box from '@components/Atoms/Box';
import Typography from '@components/Atoms/Typography';
import DateDisplay from '@components/Atoms/DateDisplay';
import ActionRequiredWrapper from '@contexts/ActionRequired/ActionRequiredWrapper';
import React from 'react';
import { MappedTestSession } from '../types';

const TestSessionCard = ({
  examName,
  testSession,
  testSessionCardContent,
  id,
  selectedTestSessionId,
}: {
  examName: string;
  testSession: MappedTestSession;
  testSessionCardContent: React.ReactNode;
  id: number;
  selectedTestSessionId: number;
}) => (
  <Box data-testid="sidebar-session-card">
    <Accordion
      defaultExpanded={id === selectedTestSessionId}
      accordionSx={{
        border: '1px solid #dcdcdc',
        borderRadius: '0px',
        boxShadow: 'none',
        '&.Mui-expanded': {
          margin: '0px',
          '& > div': {
            borderBottom: '1px solid #dcdcdc',
          },
          '& > .MuiCollapse-root': {
            borderTop: '1px solid #dcdcdc',
          },
        },
      }}
      title={
        <ActionRequiredWrapper checkPath={['LE', id]}>
          <Box
            className="actionable"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: '1.2rem',
                color: 'primary.main',
              }}
            >
              {examName}
            </Typography>
            <DateDisplay
              startDate={testSession.start_date}
              endDate={testSession.end_date}
              variant="compact"
              size="small"
              showIcon
            />
          </Box>
        </ActionRequiredWrapper>
      }
      content={testSessionCardContent}
      summarySx={{
        margin: '0px',
      }}
      detailsSx={{
        margin: '8px 0px',
      }}
    />
  </Box>
);

export default TestSessionCard;
